"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _humps = require("humps");

function isJSONRequest(headers) {
  return headers['Content-Type'] === 'application/json';
} // Serializes the request body if necessary


function serializeBody(_ref) {
  var _ref$decamelizeBody = _ref.decamelizeBody,
      decamelizeBody = _ref$decamelizeBody === void 0 ? true : _ref$decamelizeBody,
      headers = _ref.headers,
      body = _ref.body;
  if (!body || !isJSONRequest(headers)) return;
  var transformedBody = decamelizeBody ? (0, _humps.decamelizeKeys)(body) : body;
  return {
    body: JSON.stringify(transformedBody)
  };
}

var _default = serializeBody;
exports["default"] = _default;